/*
 * Ønskeliste-hjerte: marker knappen som lagt til (rødt hjerte).
 *
 * Knappene ([data-swaction="addToWishlist"][data-product-id]) styres av Swym,
 * men temaet hadde ingen synlig «lagt til»-tilstand. Her får knappen klassen
 * .is-wishlisted (farges i custom_products_cards_etc.css):
 *   - med en gang ved klikk (av/på – Swym fjerner ved andre klikk)
 *   - ved sideinnlasting for produkter som allerede ligger i ønskelisten
 *   - fjernes igjen hvis produktet tas ut av ønskelisten (f.eks. i Swym-vinduet)
 *
 * Klikk-lytteren ligger på selve knappen (ikke på document), fordi Algolia har
 * en «klikk på kortet åpner produktet»-lytter på .ais-hits-container. Swyms
 * fjern-handler stopper ikke boblingen, så uten stopPropagation her ville
 * andre klikk på hjertet åpnet produktsiden mens Swym-kallet fortsatt pågikk.
 */
(function () {
  var SELECTOR = '[data-swaction="addToWishlist"][data-product-id]';
  var wishlisted = new Set();

  function idOf(el) {
    return String(el.getAttribute('data-product-id') || '').replace(/"/g, '');
  }

  function paint(btn) {
    var on = wishlisted.has(idOf(btn));
    btn.classList.toggle('is-wishlisted', on);
    btn.setAttribute('aria-pressed', on ? 'true' : 'false');
  }

  function onClick(event) {
    // Ikke la klikket boble til kort-lytteren (Algolia) som åpner produktsiden.
    // Swyms egen onclick på samme knapp påvirkes ikke av stopPropagation.
    event.preventDefault();
    event.stopPropagation();
    var id = idOf(this);
    if (!id) return;
    if (wishlisted.has(id)) wishlisted.delete(id);
    else wishlisted.add(id);
    apply();
  }

  function apply() {
    document.querySelectorAll(SELECTOR).forEach(function (btn) {
      if (!btn.__wishlistHeart) {
        btn.__wishlistHeart = true;
        btn.addEventListener('click', onClick);
      }
      paint(btn);
    });
  }

  function fromEvent(e) {
    var d = e && e.detail && (e.detail.d || e.detail);
    return d && d.empi ? String(d.empi) : '';
  }

  function syncFromSwym(swat) {
    // Hent produktene som ligger i ønskelisten og bygg tilstanden på nytt
    var onList = function (items) {
      wishlisted.clear();
      (items || []).forEach(function (item) {
        if (item && item.empi) wishlisted.add(String(item.empi));
      });
      apply();
    };
    try {
      if (swat.api && typeof swat.api.fetch === 'function') swat.api.fetch(onList, function () {});
      else if (typeof swat.fetch === 'function') swat.fetch(onList, function () {});
    } catch (err) { /* Swym-feil skal ikke stoppe siden */ }
  }

  function onSwymReady(swat) {
    syncFromSwym(swat);

    // Hold tilstanden i synk når Swym legger til / fjerner
    if (swat.evtLayer && swat.JSEvents) {
      if (swat.JSEvents.addedToWishlist) {
        swat.evtLayer.addEventListener(swat.JSEvents.addedToWishlist, function (e) {
          var id = fromEvent(e);
          if (id) { wishlisted.add(id); apply(); }
        });
      }
      if (swat.JSEvents.removedFromWishlist) {
        swat.evtLayer.addEventListener(swat.JSEvents.removedFromWishlist, function (e) {
          var id = fromEvent(e);
          if (id) { wishlisted.delete(id); apply(); }
        });
      }
    }

    // Tilbake-knappen kan gjenopprette siden fra bfcache med gammel tilstand
    window.addEventListener('pageshow', function (e) {
      if (e.persisted) syncFromSwym(swat);
    });
  }

  apply();

  // Swym kan allerede være lastet når dette (defer) skriptet kjører
  if (window._swat && window._swat.evtLayer) {
    onSwymReady(window._swat);
  } else {
    if (!window.SwymCallbacks) window.SwymCallbacks = [];
    window.SwymCallbacks.push(onSwymReady);
  }

  // Knapper som rendres senere (karuseller, Algolia-søk, temaeditor)
  var queued = false;
  new MutationObserver(function () {
    if (queued) return;
    queued = true;
    requestAnimationFrame(function () { queued = false; apply(); });
  }).observe(document.documentElement, { childList: true, subtree: true });
})();
